import { Component, isDevMode, inject } from '@angular/core';
import { AppConfig } from './app-config';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {
  private config = inject(AppConfig);

  title = 'platform';

  constructor() {
    // const mode: string = isDevMode() ? "Development" : "Production";
    // console.log('Pienso Web is running in mode: ', mode);
  }
}
